import Vue from "vue";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import PhotoModal from "@/components/user/PhotoModal";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import moment from "moment";
import pick from "lodash.pick";
import { getAction, putAction } from "@/api/manage";
import JUpload from "@/components/jeecg/JUpload";
import store from "@/store/";
var token = Vue.ls.get(ACCESS_TOKEN);
export default {
  components: {
    PhotoModal: PhotoModal,
    JDictSelectTag: JDictSelectTag,
    JUpload: JUpload
  },
  data: function data() {
    return {
      dateFormat: "YYYY-MM-DD",
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      uploadLoading: false,
      confirmLoading: false,
      headers: {
        "X-Access-Token": token
      },
      form: this.$form.createForm(this),
      validatorRules: {
        realname: {
          rules: [{
            required: true,
            message: "请输入用户名称!"
          }]
        },
        grade: {
          rules: [{
            required: true,
            message: "请输入年级!"
          }]
        },
        photo: {
          rules: [{
            required: true,
            message: "请上传证件照!"
          }]
        },
        phone: {
          rules: [{
            required: true,
            message: "请填写手机号!"
          }, {
            validator: this.validatePhone
          }]
        },
        sex: {
          initialValue: 1,
          rules: [{
            required: true,
            message: "请选择性别!"
          }]
        },
        email: {
          rules: [{
            required: true,
            pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: "请输入正确的邮箱地址!"
          }]
        }
      },
      userInfo: {},
      modifyModalVisible: false,
      userModifyList: [],
      url: {
        userInfo: "/teaching/user/info",
        userHonor: "/teaching/teachingUserHonor/userHonor",
        editUser: "/teaching/user/edit",
        modifyUser: "/sys/sysUserModify/modify"
      },
      realname: "",
      idcard: "",
      awardId: null
    };
  },
  computed: {},
  created: function created() {
    this.getUserInfo();
    this.getModifyApply();
    this.awardId = this.$route.query.awardId;
  },
  methods: {
    moment: moment,
    getModifyApply: function getModifyApply() {
      var _this = this;
      getAction("/sys/sysUserModify/myModifyApply").then(function (res) {
        if (res.success && res.result) {
          _this.userModifyList = res.result;
          for (var i = 0; i < res.result.length; i++) {
            if (res.result[i].status == -1) {
              _this.$info({
                title: "提示",
                content: "照片审核不通过，请重新上传",
                onOk: function onOk() {}
              });
            }
          }
        }
      });
    },
    //同步用户信息
    getUserInfo: function getUserInfo() {
      var that = this;
      getAction(this.url.userInfo).then(function (res) {
        if (res.success) {
          that.userInfo = res.result;
          that.$nextTick(function () {
            that.form.setFieldsValue(pick(that.userInfo, "username", "idcard", "sex", "realname", "email", "photo", "grade", "phone", "avatar"));
          });
          store.commit("SET_NAME", {
            username: that.userInfo.username,
            realname: that.userInfo.realname
          });
          store.commit("SET_AVATAR", that.userInfo.avatar_url);
          store.commit("SET_USER_INFO", that.userInfo);
        }
      });
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      var that = this;
      var values = that.form.getFieldsValue();
      console.log(values);
      that.confirmLoading = true;
      if (!values.birthday) {
        values.birthday = "";
      } else {
        values.birthday = values.birthday.format(this.dateFormat);
      }
      var formData = Object.assign(this.userInfo, values);
      console.log(formData);
      // that.addDepartsToUser(that,formData); // 调用根据当前用户添加部门信息的方法
      //putAction(that.url.editUser, formData)
      putAction(this.url.modifyUser, formData).then(function (res) {
        if (res.success) {
          that.getUserInfo();
          that.$message.success(res.message);
          that.$emit("ok");
          if (res.message == "提交申请成功") {
            _this2.$info({
              title: "提示",
              content: "修改身份证和姓名将在3个工作日内审核完毕",
              onOk: function onOk() {}
            });
          }
        } else {
          that.$message.warning(res.message);
        }
      }).finally(function () {
        that.confirmLoading = false;
      });
    },
    // handleSubmitIdcard(){
    //   putAction(this.url.modifyUser, {
    //     id: this.userInfo.id,
    //     realname: this.userInfo.realname,
    //     idcard: this.userInfo.idcard
    //   }).then((res) => {
    //       if (res.success) {
    //         this.getUserInfo();
    //         this.$info({
    //           title: "提示",
    //           content: "将在3个工作日内审核完毕",
    //           onOk() {},
    //         });
    //       } else {
    //         this.$message.warning(res.message);
    //       }
    //     })
    //     .finally(() => {
    //       this.confirmLoading = false;
    //     });
    // },
    photoChange: function photoChange(key, photoId) {
      var _this3 = this;
      putAction(this.url.modifyUser, {
        id: this.userInfo.id,
        photo: photoId,
        awardId: this.awardId
      }).then(function (res) {
        if (res.success) {
          _this3.getUserInfo();
          _this3.$info({
            title: "提示",
            content: "修改证件照将在3个工作日内审核完毕",
            onOk: function onOk() {}
          });
        } else {
          _this3.$message.warning(res.message);
        }
      }).finally(function () {
        _this3.confirmLoading = false;
      });
    },
    validatePhone: function validatePhone(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        if (new RegExp(/^1[3456789]\d{9}$/).test(value)) {
          var params = {
            tableName: "sys_user",
            fieldName: "phone",
            fieldVal: value,
            dataId: this.userId
          };
          duplicateCheck(params).then(function (res) {
            if (res.success) {
              callback();
            } else {
              callback("手机号已存在!");
            }
          });
        } else {
          callback("请输入正确格式的手机号码!");
        }
      }
    }
  }
};